import React, { useState } from "react";
import { Modal, Box, Button, FormControlLabel, Checkbox } from "@mui/material";
import { fetchAuthSession } from "@aws-amplify/auth";
import config from "../utils/Constants";

const FHIRResourceModal = ({ open, onClose }) => {
  const [selectedResources, setSelectedResources] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // FHIR resource options
  const fhirResources = ["Patient", "Condition", "Observation", "Appointment"];

  const handleCheckboxChange = (resource) => {
    setSelectedResources((prev) =>
      prev.includes(resource)
        ? prev.filter((r) => r !== resource)
        : [...prev, resource]
    );
  };

  // Send FHIR resources via backend proxy
  const handleSubmit = async () => {
    setLoading(true);
    setErrorMessage("");

    try {
      const apiUrl = config.getDynamicApiUrl();
      const session = await fetchAuthSession();
      const token = session.tokens.accessToken.toString();

      for (const resource of selectedResources) {
        try {
          const response = await fetch(`${apiUrl}/api/v1/integrations/canvas/fhir-proxy/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              resource_type: resource,
              payload: { resourceType: resource },
            }),
          });

          if (!response.ok) {
            const errText = await response.text();
            console.error(`Error creating ${resource}:`, errText);
            setErrorMessage(`Error creating ${resource}: ${errText}`);
          } else {
            console.log(`${resource} created successfully.`);
          }
        } catch (error) {
          console.error(`Failed to create ${resource}:`, error);
          setErrorMessage(`Failed to create ${resource}: ${error.message}`);
        }
      }
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      slotProps={{
        sx: {
          backgroundColor: "rgba(238, 12, 12, 0.96)",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <h3>Select FHIR Resources to Create</h3>
        {fhirResources.map((resource) => (
          <FormControlLabel
            key={resource}
            control={
              <Checkbox
                checked={selectedResources.includes(resource)}
                onChange={() => handleCheckboxChange(resource)}
              />
            }
            label={resource}
            style={{ display: "block" }}
          />
        ))}

        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Button onClick={onClose} color="secondary" disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default FHIRResourceModal;
